module.exports = __webpack_public_path__ + "fc594ad4e870a202f39d51b870f04217.fbx";